import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareListCustomEmbedClassicRoute: InvariantJiraRoute = {
	name: 'software-list-classic-custom-embed',
	path: '/jira/software/c/projects/:projectKey/list/:navigationItemId/embed',
};
